import React, {  useEffect, useState,useRef, useContext, Dispatch, SetStateAction, useMemo } from "react";
import "./MenuPage.css"
import { TfiClose } from "react-icons/tfi";
import { contentMenuList, Menu, ReviewProps,typeDailyMenu} from "../../../components/types/types";
import MaskBackground from "../../../components/maskBackground/maskBackground";
import { AppContext } from "../../../context/AppContext";
import MenuRestau from "../../../components/Menu/menu";
import Loading from "../../../components/loading/loading";

const BlockReview = React.lazy(() => import("../../../components/blockReview/BlockReview"));
function getLcpImageUrl(menu: contentMenuList): string | null {
    if (!menu?.menu) return null;
    try {
        const pages = Array.isArray(menu.menu) ? menu.menu : [];
        for (const page of pages) {
            const candidates = Array.isArray(page) ? page : [page];
            for (const p of candidates) {
                if (p?.imgback && typeof p.imgback === 'string' && p.imgback.startsWith('http')) {
                    return p.imgback;
                }
            }
        }
    } catch {
        return null;
    }
    return null;
}
interface MenuPageProps  {
    listMenu:contentMenuList[],
    idRestaurant:number,
    note:number,
    dateUpdate:Date,
    dailyMenu:typeDailyMenu,
    listReview:ReviewProps[],
    setListReview:Dispatch<SetStateAction<ReviewProps[]>>,
    reviewLoad:boolean,
    setReviewLoad:Dispatch<SetStateAction<boolean>>,
    nbrReviewLoad:number,
    photoRestaurateur:string,
    setPhotoRestaurateur:Dispatch<SetStateAction<string>>,
} 

const MenuPage:React.FC<MenuPageProps> = ({listMenu,reviewLoad,nbrReviewLoad,setReviewLoad,listReview,setListReview,photoRestaurateur,setPhotoRestaurateur,dailyMenu,dateUpdate,idRestaurant,note}) => {
    const {setShowPlat} = useContext(AppContext)
    
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [fullPlat,setFullPlat] = useState('')
    const [fullScreenMenu,setFullScreenMenu] = useState(false)
    const firstVisibleMenu = useMemo(() => {
        const normalMenus = listMenu.map((menu, index) => ({
            type: "menu" as const,
            data: menu,
            sourceIndex: index,
        }));

        const dailyItems =
            dailyMenu && dailyMenu.image
                ? [{ type: "daily" as const, data: dailyMenu, sourceIndex: null }]
                : [];

        const sortedItems = [...normalMenus, ...dailyItems].sort((a, b) => {
            const aOrder = a.data.display_order ?? 0;
            const bOrder = b.data.display_order ?? 0;

            if (aOrder !== bOrder) return aOrder - bOrder;
            if (a.type === "daily" && b.type === "menu") return -1;
            if (a.type === "menu" && b.type === "daily") return 1;
            return 0;
        });

        return sortedItems[0]?.type === "menu" ? sortedItems[0].data : null;
    }, [listMenu, dailyMenu]);

    useEffect(() => {
        if (!firstVisibleMenu) return;

        const lcpImgUrl = getLcpImageUrl(firstVisibleMenu);
        if (!lcpImgUrl) return;

        const existing = document.querySelector(`link[rel="preload"][href="${lcpImgUrl}"]`);
        if (existing) return;

        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = lcpImgUrl;
        document.head.appendChild(link);

        return () => {
            if (document.head.contains(link)) {
                document.head.removeChild(link);
            }
        };
    }, [firstVisibleMenu]);
    useEffect(() => {   
        if (typeof window === 'undefined') return;
        const BREAKPOINT = 1050;
        const canCrossBreakpoint = () => {
            const w = window.innerWidth;
            const h = window.innerHeight;
            const minSide = Math.min(w, h);
            const maxSide = Math.max(w, h);
            return minSide < BREAKPOINT && maxSide > BREAKPOINT;
        };

        const isLarge = () => window.innerWidth > BREAKPOINT;
        const initialIsLarge = isLarge();
        
        const handleChange = () => {
            if (!canCrossBreakpoint()) return;
            const nowIsLarge = isLarge();
            if (nowIsLarge !== initialIsLarge) {
            window.location.reload();
            }
        };
        window.addEventListener('orientationchange', handleChange);
        window.addEventListener('resize', handleChange);

        return () => {
            window.removeEventListener('orientationchange', handleChange);
            window.removeEventListener('resize', handleChange);
        };
    },[])

    const currentDailyMenu = React.useMemo(() => {
        if(dailyMenu.image && Array.isArray(dailyMenu.dates)) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (dailyMenu.dates.length > 1) {
                
                const startDate = new Date(dailyMenu.dates[0]);
                const endDate = new Date(dailyMenu.dates[1]);
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(0, 0, 0, 0);
                return !(today < startDate || today > endDate);
            } else if (dailyMenu.dates.length === 1) {
                const menuDate = new Date(dailyMenu.dates[0]);
                menuDate.setHours(0, 0, 0, 0);
                return today.getTime() === menuDate.getTime();
            } else return false;
        } else return false
    }, [dailyMenu]);

    const fetchReview = async (idResto:number) => {
        try {
            if(reviewLoad) return
            const [avisRes, infoRes] = await Promise.all([
                fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getAvis`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ idResto }),
                }),
                fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getInfoResponse`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ idResto }),
                }),
            ]);

            const avisData = await avisRes.json();
            const infoData = await infoRes.json();

            setListReview(avisData.reviews || [])
            setReviewLoad(true)
            if (infoData.success && infoData.info?.photo) {
                setPhotoRestaurateur(infoData.info.photo)
            } 
        } catch (e) {
            console.error(e);
        }
    }
    useEffect(() => {
        if (!idRestaurant || idRestaurant === -1) return;
        if (reviewLoad) return;

        const run = () => fetchReview(idRestaurant);

        const w = globalThis;

        if ("requestIdleCallback" in w) {
            const id = (w as any).requestIdleCallback(run, { timeout: 1500 });
            return () => (w as any).cancelIdleCallback?.(id);
        }
        const t = setTimeout(run, 400);
        return () => clearTimeout(t);
    }, [idRestaurant, reviewLoad]);
    useEffect(() => {
        if(idRestaurant && idRestaurant !== -1) {
            const observerPlat = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        setShowPlat([-1,0,0])
                    }
                },
                { threshold: 0.3 } 
            );

            let timer = window.setTimeout(() => {
                if (containerRef.current) {
                    observerPlat.observe(containerRef.current);
                }
            }, 800);

            return () => {
                window.clearTimeout(timer);
                observerPlat.disconnect();
            }
        }
    }, [idRestaurant]);
    
    const updateAddResponse = React.useCallback((id:number,response:string) => {
        setListReview(prevList =>
            prevList.map(review =>
                review.idavis === id
                    ? { 
                        ...review, 
                        response, 
                        post_date_response: new Date() 
                    }
                    : review
            )
        );
    }, []);
    const updateDeleteReview = React.useCallback((id:number) => {
         setListReview(prevList => prevList.filter(elem => elem.idavis !== id));
    }, []);
    const updateDeleteResponse = React.useCallback((id:number) => {
        setListReview(prevList =>
            prevList.map(elem =>
                elem.idavis !== id ? elem : { ...elem, response: "" }
            )
        );
    }, []);
    const updateNewReview = React.useCallback((newReview:ReviewProps) => {
        setListReview(prevList => {
            const prevListFilter = prevList.filter(elem => elem.iduser !== newReview.iduser);
            return [newReview, ...prevListFilter];
        });
    }, []);

    return (
        <>
        <div className='menuCorpRestau primaryBack' id="menuCorpRestau"  >
            <MenuRestau fullScreen={fullScreenMenu} listMenu={listMenu} setFullScreen={setFullScreenMenu} setFullPlat={setFullPlat} {...currentDailyMenu ? {currentDaily:true,dailyMenu:dailyMenu} : {}}/>
        </div>
        {
            fullPlat !== '' ? 
            <div onClick={() => setFullPlat('')}>
                <MaskBackground zIndex={20} closeFunction={() => setFullPlat('')}/>
                <div className="containerFullImgPlat">
                    <TfiClose style={{top:'1em', right:'1em', padding:'0.3em'}} className="fullScreen pointer lowOpacityHover" size={20} />
                    <img className="fullIMG" src={fullPlat} loading="lazy" decoding="async" alt="plat large"/> 
                </div>
                
            </div>
            : undefined 
        }
        <div  ref={containerRef} className="reviewsSuspenseShell">
            <React.Suspense fallback={<div style={{minHeight:'650px'}}><Loading /></div>}>
                <BlockReview idResto={idRestaurant} ListAvis={listReview} note={note} updateNewReview={updateNewReview} updateDeleteResponse={updateDeleteResponse} updateAddResponse={updateAddResponse} updateDeleteReview={updateDeleteReview} imgRestaurateur={photoRestaurateur} nbrReviewLoad={nbrReviewLoad}/>
            </React.Suspense>
        </div>
        </>
    )
}

export default MenuPage